<template>
  <m-dialog ref="detailDlg" :isclose="true" :btnsave="false" :save="false" :fullscreen="true" :title="`Detail Aktivitas User `">
    <span class="text-h5 black--text">Summary Score Per Unit</span>
    <p class="blue--text text-caption">{{ items.user_name }}</p>
    <div v-if="groupedData && items && items.scores">
      <v-data-table :headers="headers" :items="formattedData" :items-per-page="20" class="elevation-1">
        <template v-slot:item="{ item }">
          <tr>
            <td>{{ item.unit }}</td>
            <td>{{ item.assignmentCompletion }}</td>
            <td>{{ item.assignmentHighScores }}</td>
            <td>{{ item.testCompletion }}</td>
            <td>{{ item.testHighScores }}</td>
          </tr>
        </template>
      </v-data-table>
    </div>
    <v-row dense>
      <v-col cols="12">
        <v-divider class="py-4"></v-divider>
        <span class="text-h5 black--text">Detail Activity Per Unit</span>
        <p class="blue--text text-caption">{{ items.user_name }}</p>
      </v-col>
      <v-col cols="12" md="6" v-for="(item, index) in items.scores" :key="index" class="mb-3">
        <!-- Mengubah ukuran kolom menjadi 6 pada md ke atas agar 2 card bisa sejajar -->
        <v-card class="ma-0">
          <v-card-title class="blue--text">{{ item.activity_path }}</v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" md="4"><strong>Activity Path:</strong></v-col>
              <v-col cols="12" md="8" class="success--text">{{ item.activity_name }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="4"><strong>Type:</strong></v-col>
              <v-col cols="12" md="8" class="deep-orange--text">{{ item.type }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="4"><strong>Highest Score:</strong></v-col>
              <v-col cols="12" md="8">{{ item.score.highest !== null ? item.score.highest : "N/A" }}</v-col>
            </v-row>
            <v-row dense>
              <v-col cols="12" md="4"><strong>Completed:</strong></v-col>
              <v-col cols="12" md="8">({{ item.completed }}/{{ item.total }})</v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </m-dialog>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  props: {
    items: {
      type: Object,
      default: { scores: [], user_name: "" }
    }
  },

  data() {
    return {
      itemsPerPage: 5,
      headers: [
        { text: "Unit", value: "unit" },
        { text: "Assignment Completion", value: "assignmentCompletion" },
        { text: "Assignment Scores", value: "assignmentHighScores" },
        { text: "Test Completion", value: "testCompletion" },
        { text: "Test Scores", value: "testHighScores" }
      ]
    };
  },
  methods: {
    open() {
      let x = this.$refs.detailDlg.open();
      this.$validator.reset();
      return x;
    },

    extractData(str) {
      return str.split(" -> ")[0];
    }
  },

  computed: {
    formattedData() {
      return this.groupedData.map(item => ({
        unit: item.unit,
        assignmentCompletion: `${item.data.assignment.completed}/${item.data.assignment.total}`,
        assignmentHighScores: item.data.assignment.averageHighest !== null ? item.data.assignment.averageHighest.toFixed(2) : "N/A",
        testCompletion: `${item.data.test.completed}/${item.data.test.total}`,
        testHighScores: item.data.test.averageHighest !== null ? item.data.test.averageHighest.toFixed(2) : "N/A"
      }));
    },
    groupedData() {
      if (this.items && this.items.scores) {
        const result = {};

        this.items.scores.forEach(item => {
          // Cek jika highest bukan null sebelum memproses item
          if (item.score.highest !== null) {
            // Ambil unit dari activity_path
            const unit = item.activity_path.split("->")[0].trim();
            const type = item.type;

            // Jika unit belum ada, inisialisasi strukturnya
            if (!result[unit]) {
              result[unit] = {
                assignment: { total: 0, completed: 0, totalHighest: 0, count: 0, averageHighest: null },
                test: { total: 0, completed: 0, totalHighest: 0, count: 0, averageHighest: null }
              };
            }

            // Tambahkan total dan completed ke unit dan type yang sesuai
            result[unit][type].total += item.total;
            result[unit][type].completed += item.completed;

            // Tambahkan highest ke totalHighest dan tingkatkan count
            result[unit][type].totalHighest += item.score.highest;
            result[unit][type].count += 1;
          }
        });

        // Hitung rata-rata highest untuk setiap unit dan type
        Object.keys(result).forEach(unit => {
          ["assignment", "test"].forEach(type => {
            const typeData = result[unit][type];
            if (typeData.count > 0) {
              typeData.averageHighest = typeData.totalHighest / typeData.count;
            } else {
              typeData.averageHighest = null; // jika tidak ada data highest
            }
          });
        });

        // Konversi hasil menjadi array objek unit
        return Object.keys(result).map(unit => ({
          unit: unit,
          data: result[unit]
        }));
      }
    }
  }
};
</script>
